import { styled, SxProps, Theme } from '@mui/material';
import MuiAccordion from '@mui/material/Accordion';

interface AccordionProps {
  children: NonNullable<React.ReactNode>;
  defaultExpanded?: boolean;
  disabled?: boolean;
  disableGutters?: boolean;
  expanded?: boolean;
  onChange?: (event: React.SyntheticEvent, expanded: boolean) => void;
  sx?: SxProps<Theme>;
  //   TransitionComponent?: React.JSXElementConstructor<
  //     TransitionProps & { children?: React.ReactElement<any, any> }
  //   >;
  //   TransitionProps?: TransitionProps;
  bgcolor: string;
  bordercolor?: string;
  marginbottom?: number;
  margintop?: number;
}

interface AccordionPropsType {
  bgcolor: string;
  isborderbottom?: boolean;
  bordercolor?: string;
  marginbottom?: number;
  margintop?: number;
  sx?: SxProps<Theme>;
  children: NonNullable<React.ReactNode>;
  onChange?: (event: React.SyntheticEvent, expanded: boolean) => void;
  expanded?: boolean;
  TransitionProps?: {
    onEntered?: () => void;
  };
}

const MuiAccordionOne = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme, bgcolor, bordercolor, marginbottom, margintop }) => ({
  backgroundColor: bgcolor,
  marginTop: `${margintop}px`,
  marginBottom: `${marginbottom}px`,
  borderBottom: bordercolor ? `1px solid ${bordercolor}` : '',
  // '&:not(:last-child)': {
  //   marginBottom: `${marginbottom}px`,
  //   borderBottom: bordercolor ? `1px solid ${bordercolor}` : '',
  // },

  '&:not(:first-of-type)::before': {
    backgroundColor: bgcolor,
  },
}));

const Accordion = ({
  bgcolor,
  bordercolor,
  marginbottom,
  margintop,
  children,
  sx,
  onChange,
  ...props
}: AccordionPropsType) => {
  return (
    <MuiAccordionOne
      bgcolor={bgcolor}
      bordercolor={bordercolor}
      marginbottom={marginbottom}
      margintop={margintop}
      sx={sx}
      onChange={onChange}
      {...props}
    >
      {children}
    </MuiAccordionOne>
  );
};

export default Accordion;
